// Hlášení pro čtečku přes skryté aria-live oblasti. Pomalé události jdou do „polite“,
// odpovědi na stisk klávesy (pohyb kurzoru, R, H) do „assertive“, aby přerušily starší text.

let politeEl: HTMLElement;
let assertiveEl: HTMLElement;
let enabled = true;
let flip = false;
const pending: string[] = [];
let politeTimer: number | null = null;

export function initAnnouncer() {
  politeEl = document.getElementById("live-polite")!;
  assertiveEl = document.getElementById("live-assertive")!;
}

/** V režimu „obraz“ se hlášení nevypisují (nikdo je nečte, a nezahlcují se tak případné čtečky). */
export function setAnnouncerEnabled(on: boolean) {
  enabled = on;
}

function write(el: HTMLElement, text: string) {
  // Stejný text dvakrát po sobě by čtečka nemusela přečíst, proto střídáme neviditelný znak.
  flip = !flip;
  el.textContent = text + (flip ? " " : "");
}

/** Pomalá událost. Krátce sdružujeme, aby se hlášení nepřebíjela. */
export function announce(text: string) {
  if (!enabled || !text) return;
  pending.push(text);
  if (politeTimer !== null) return;
  politeTimer = window.setTimeout(() => {
    politeTimer = null;
    write(politeEl, pending.splice(0).join(" "));
  }, 120);
}

/** Okamžitá odpověď na akci hráče. */
export function say(text: string) {
  if (!enabled || !text) return;
  write(assertiveEl, text);
}

/** Hlášení, které platí vždy (stav spojení), i v režimu obraz se zapíše. */
export function announceAlways(text: string) {
  write(politeEl, text);
}
